import mediator from "@tvg/mediator";
import tvgConf from "@tvg/conf";
import { get } from "lodash";
import promoService from "@tvg/api/pro";
import { handleOptinDataLayerUpdate } from "@tvg-mar/utils/gtmEventHandlers";

export const optinUser = (accountNumber, id, setIsUserOpted, setOptinError) => {
  promoService
    .postUserPromoOptin(accountNumber, id)
    .then(() => {
      setIsUserOpted(true);
      handleOptinDataLayerUpdate("Success", id);
    })
    .catch((error) => {
      const exception =
        get(error, "response.data.exception", "") !== ""
          ? get(error, "response.data.exception", "")
          : error;

      setOptinError(exception);
      handleOptinDataLayerUpdate("Failure", id);
    });
};

export const handleUserOptinClick = (
  user,
  promoId,
  setIsUserOpted,
  setOptinError
) => {
  const { isLogged, accountNumber } = user;

  if (!isLogged && accountNumber === "") {
    if (tvgConf.product === "iosnative") {
      window.handleNativeMessages("OPEN_LOGIN_MODAL_WEBVIEW", {
        currentUrl: window.location.href,
        promoId
      });
    } else {
      mediator.base.dispatch({
        type: "OPEN_LOGIN",
        payload: {
          callback: (error, success) => {
            if (get(success, "status", "fail") === "success") {
              optinUser(
                get(success, "data.userDetails.accountNumber", ""),
                promoId,
                setIsUserOpted,
                setOptinError
              );
            }
          }
        }
      });
    }
  } else {
    optinUser(accountNumber, promoId, setIsUserOpted, setOptinError);
  }
};

export const handleReactNativeEvents = (
  optinInfo,
  sentOptinEvents,
  promoId,
  setOptinError,
  setSentOptinEvents
) => {
  if (!sentOptinEvents) {
    handleOptinDataLayerUpdate(optinInfo.state, promoId);

    if (optinInfo.state !== "Success") {
      setOptinError(get(optinInfo, "error", ""));
    }

    setSentOptinEvents(true);
  }
};
